import Vue from 'vue';
import Vuex from 'vuex';
// import { state, actions, mutations } from './root';
import user from './module/user';
import permission from './module/permission';
// import getters from './getters';

const mutat_types = {
  LANGUAGE: 'LANGUAGE',
  GROUPID: 'GROUPID',
  OPERATORAC: 'OPERATORAC',
  OPERATORID: 'OPERATORID',
  DOMAIN: 'DOMAIN',
  CMS: 'CMS',
  VERSION: 'VERSION',
  CURRENCY: 'CURRENCY',
  CURRENCYLIST: 'CURRENCYLIST',
  EXCHANGERATE: 'EXCHANGERATE',
  GAMELIST: 'GAMELIST',
};

const m_state = {
  lang: 'en',
  operatorID: '',
  operatorAC: '',
  groupID: '',
  domain: {},
  cms: {},
  version: '',
  currency: '',
  currencyList: [],
  exchangeRate: [],
  gameList: [],
};

const mutations = {
  [mutat_types.LANGUAGE](state, payload){
    state.lang = payload;
    // 設定 Vue config 將會改變使用的語系
    Vue.config.lang = state.lang;
  },
  [mutat_types.OPERATORID](state, payload){state.operatorID = payload},
  [mutat_types.OPERATORAC](state, payload){state.operatorAC = payload},
  [mutat_types.GROUPID](state, payload){state.groupID = payload},
  [mutat_types.DOMAIN](state, payload){state.domain = payload},
  [mutat_types.CMS](state, payload){state.cms = payload},
  [mutat_types.VERSION](state, payload){state.version = payload},
  [mutat_types.CURRENCY](state, payload){state.currency = payload},
  [mutat_types.CURRENCYLIST](state, payload){state.currencyList = payload},
  [mutat_types.EXCHANGERATE](state, payload){state.exchangeRate = payload},
  [mutat_types.GAMELIST](state, payload){state.gameList = payload},
};

const actions = {
  setLanguage({commit}, payload){commit(mutat_types.LANGUAGE, payload)},
  setOperatorID({commit}, payload){commit(mutat_types.OPERATORID, payload)},
  setOperatorAC({commit}, payload){commit(mutat_types.OPERATORAC, payload)},
  setGroupID({commit}, payload){commit(mutat_types.GROUPID, payload)},
  setDomain({commit}, payload){commit(mutat_types.DOMAIN, payload)},
  setCms({commit}, payload){commit(mutat_types.CMS, payload)},
  setVersion({commit}, payload){commit(mutat_types.VERSION, payload)},
  setCurrency({commit}, payload){commit(mutat_types.CURRENCY, payload)},
  setCurrencyList({commit}, payload){commit(mutat_types.CURRENCYLIST, payload)},
  setExchangeRate({commit}, payload){commit(mutat_types.EXCHANGERATE, payload)},
  setGameList({commit}, payload){commit(mutat_types.GAMELIST, payload)},
};

const getters = {
  getToken: state => state.user.token,
  getOperator: state => state.user.operator,
  getOperatorDefaultRouter: state => state.user.operatorDefaultRouter,
  getOperatorDefaultRouterTab: state => state.user.operatorDefaultRouterTab,
  getOpenAutoSearch: state => state.user.openAutoSearch,
  getDrawerStatus: state => state.user.drawerStatus,
  getBreadShow: state => state.user.breadShow,
  getDialogShow: state => state.user.dialogShow,
  getStatusDialog: state => state.user.statusDialog,

  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,

  getLanguage: state => state.lang,
  getDomain: state => state.domain,
  getCms: state => state.cms,
  getVersion: state => state.version,
  getCurrency: state => state.currency,
  getCurrencyList: state => state.currencyList,
  getExchangeRate: state => state.exchangeRate,
  getGameList: state => state.gameList,
};

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    permission,
  },
  state: m_state,
  mutations,
  actions,
  getters,
});
